import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

import { CustomerFacingMembershipInfo } from '../../py-generated/datalouder/membership/types';
import SwitchToStripeSubscriptionView from './SwitchToStripeSubscriptionView';

interface Props {
  info: CustomerFacingMembershipInfo;
}

const SwitchToStripeSubscriptionSpan: React.FC<Props> = ({
  info: { expire_at: expireAt },
}) => {
  const { t, i18n } = useTranslation();
  const [modalVisible, showModal] = useState(false);

  const handleClickSwitch = (e: React.MouseEvent) => {
    e.preventDefault();
    showModal(true);
  };

  const modal = () =>
    modalVisible && (
      <Modal
        show
        size="xl"
        fullscreen="lg-down"
        centered
        onHide={() => showModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('switch-to-stripe-subscription')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SwitchToStripeSubscriptionView expireAt={expireAt} />
        </Modal.Body>
      </Modal>
    );

  return i18n.language === 'zh' ? (
    <Alert variant="secondary">
      閣下帳戶沒有可以延長的訂閱，若您希望延長訂閱，請先
      <a href="#" onClick={handleClickSwitch}>
        轉換為 Stripe 訂閱
      </a>
      。{modal()}
    </Alert>
  ) : (
    <Alert variant="secondary">
      There isn&rsquo;t an extendable subscription in your account. To extend
      your subscription, please{' '}
      <a href="#" onClick={handleClickSwitch}>
        switch to a Stripe subscription
      </a>
      .{modal()}
    </Alert>
  );
};

export default SwitchToStripeSubscriptionSpan;
